import { createBrowserRouter } from 'react-router-dom';
import AdminPanel from '../pages/AdminPanel';
import AdminLogin from '../pages/AdminLogin';
import Dashboard from '../pages/Dashboard';
import AllProducts from '../pages/AllProducts';
import AllCategory from '../pages/AllCategory';
import AllBrands from '../pages/AllBrands';
import AllSubCategory from '../pages/AllSubCategory';
import AllBanner from '../pages/AllBanner';
import AllCustomers from '../pages/AllCustomers';
import AllOrders from '../pages/AllOrders';
import TodayOrders from '../pages/TodayOrders';
import WeeklyOrders from '../pages/WeeklyOrders';
import MonthlyOrders from '../pages/MonthlyOrders';
import ChangePassword from '../pages/ChangePassword';
import EditOrder from '../pages/EditOrder';
import OrderHistory from '../pages/OrderHistory';
import Invoice from '../pages/Invoice';
import ProductForm from '../components/ProductForm';

const router = createBrowserRouter([
  {
    path: "/",
    element: <AdminLogin />,           // ← Directly show admin login on root "/"
  },
  {
    path: "/admin-login",
    element: <AdminLogin />,
  },
  {
    path: "/admin-panel",
    element: <AdminPanel />,
    children: [
      {
        path: "",                      // /admin-panel → shows Dashboard
        element: <Dashboard />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "all-customers",
        element: <AllCustomers />,
      },
      {
        path: "all-products",
        element: <AllProducts />,
      },
      {
        path: "add-product",
        element: <ProductForm />,
      },
      {
        path: "all-category",
        element: <AllCategory />,
      },
      {
        path: "all-brand",
        element: <AllBrands />,
      },
      {
        path: "all-subCategory",
        element: <AllSubCategory />,
      },
      {
        path: "all-banner",
        element: <AllBanner />,
      },
      {
        path: "all-orders",
        element: <AllOrders />,
      },
      {
        path: "today-orders",
        element: <TodayOrders />,
      },
      {
        path: "weekly-orders",
        element: <WeeklyOrders />,
      },
      {
        path: "monthly-orders",
        element: <MonthlyOrders />,
      },
      {
        path: "change-password",
        element: <ChangePassword />,
      },
      {
        path: "edit-order",
        element: <EditOrder />,
      },
      {
        path: "order-history",
        element: <OrderHistory />,
      },
      {
        path: "invoice/:orderId",
        element: <Invoice />,
      },
    ],
  },
  // Optional: 404 / catch-all route (you can customize later)
  {
    path: "*",
    element: <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>404 - Page Not Found</h1>
      <p>This is an admin-only application.</p>
      <a href="/admin-login">Go to Admin Login</a>
    </div>,
  },
]);

export default router;